import * as yup from "yup";

import { MAX_PERCENTAGE, MAX_RETIREMENT_AGE, MIN_CURRENT_AGE, MIN_PERCENTAGE } from "@constants";
import { Translations, i18n } from "@i18n";
import { ProjectionCalculationFormValues } from "./types";

export const validationSchema: yup.SchemaOf<ProjectionCalculationFormValues> = yup.object().shape({
  age: yup
    .number()
    .typeError(i18n.t(Translations.ProjectionInfoAgeInputRequired))
    .required(i18n.t(Translations.ProjectionInfoAgeInputRequired))
    .min(
      MIN_CURRENT_AGE,
      i18n.t(Translations.ProjectionInfoAgeInputMin, {
        age: MIN_CURRENT_AGE,
      }),
    )
    .max(
      MAX_RETIREMENT_AGE,
      i18n.t(Translations.ProjectionInfoAgeInputMax, {
        age: MAX_RETIREMENT_AGE,
      }),
    ),
  percentage: yup
    .number()
    .typeError(i18n.t(Translations.ProjectionInfoPercentageInputRequired))
    .required(i18n.t(Translations.ProjectionInfoPercentageInputRequired))
    .min(
      MIN_PERCENTAGE,
      i18n.t(Translations.ProjectionInfoPercentageInputMin, {
        value: MIN_PERCENTAGE,
      }),
    )
    .max(
      MAX_PERCENTAGE,
      i18n.t(Translations.ProjectionInfoPercentageInputMax, {
        value: MAX_PERCENTAGE,
      }),
    ),
});
